let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("2QWiR")).then(() => parcelRequire('5iY9p'));